// Configuration API centralisée
// Détecte automatiquement le bon backend selon l'environnement
import axios from 'axios';

function getApiUrl() {
  // REACT_APP_BACKEND_URL (set at build time via Vercel env) prend toujours la priorité
  // Depuis le 11/06/2026 : pointe sur https://abracadabati-production.up.railway.app
  // (l'ancien sous-domaine api.abracadabati.com n'a plus d'enregistrement DNS)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // Fallback : même domaine (VPS avec nginx qui proxifie /api/* vers FastAPI)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return '';
}

export const API_URL = getApiUrl();

// --- Garde-fou panne backend ---
// Quand l'API ne répond pas (serveur down, pare-feu), les fetch GET restaient
// suspendus de longues secondes et figeaient toutes les pages. On borne les
// GET vers /api/ à 6 s : au-delà, la requête est coupée et les fallbacks démo
// des pages prennent le relais. Sans effet sur un backend sain, sur les
// POST/uploads, ni sur les appels qui gèrent déjà leur propre `signal`.
const API_TIMEOUT_MS = 6000;

if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = (
        (init && init.method) ||
        (typeof input === 'object' && input && input.method) ||
        'GET'
      ).toUpperCase();
      const isApiCall =
        url.startsWith('/api/') ||
        (API_URL && url.startsWith(`${API_URL}/api/`));
      if (isApiCall && method === 'GET' && !(init && init.signal)) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), API_TIMEOUT_MS);
        return nativeFetch(input, { ...init, signal: controller.signal }).finally(
          () => clearTimeout(timer)
        );
      }
    } catch (e) {
      // Au moindre doute, comportement réseau normal
    }
    return nativeFetch(input, init);
  };
}

// Même garde-fou pour les appels axios (Footer, bannières pub, admin) :
// timeout 6 s sur les GET qui n'en définissent pas déjà un.
axios.interceptors.request.use((config) => {
  if ((config.method || 'get').toLowerCase() === 'get' && !config.timeout) {
    config.timeout = API_TIMEOUT_MS;
  }
  return config;
});

export default API_URL;
